require('./google_map_style');


let map = null;
let userMarker = null;
const markerArr = [];


function initMapNew() {
    const element = document.querySelector('#sr-google-map.seasonal-rental-google-map')
    if (!element) return;
    map = new google.maps.Map(element, {
        streetViewControl: false,
        scrollwheel: true,
        disableDefaultUI: true,
        zoomControl: true,
        styles: googleMapStyle,
    });

    initMarkers(map);

    scaleMapToFitMakers(map, markerArr);
}


function initMarkers(map) {
    const markerInfoWindow = new google.maps.InfoWindow();
    markerInfoWindow.setOptions({pixelOffset: new google.maps.Size(0, -30)});
    google.maps.event.addListener(map, 'click', (event) => {
        markerInfoWindow.close();
    });

    $.getJSON(DJANGO.urls.storesJsonData, function (jsonObj) {
        const stores = jsonObj.features;

        for (const store of stores) {
            const lat = store.geometry.coordinates[0];
            const lng = store.geometry.coordinates[1];

            const iconUrlBase = `${window.location.protocol}//${window.location.host}`;
            const iconUrlPath = `/static/img/season_rental/markers/marker-2.png`;
            const iconUrlFull = iconUrlBase + iconUrlPath;
            const icon = {
                url: iconUrlFull,
                scaledSize: new google.maps.Size(32, 49),
            };

            const marker = new google.maps.Marker({
                position: {lat: lat, lng: lng},
                map: map,
                icon: icon,
            });
            marker.storeData = store.properties;

            marker.addListener('click', () => {
                renderMarker(marker, markerInfoWindow);
            });

            markerArr.push(marker);
        }

        scaleMapToFitMakers(map, markerArr)
    });
}


function renderMarker(marker, markerInfoWindow) {
    const id = marker.storeData.id;
    const store_name = marker.storeData.store_name;
    const phone = marker.storeData.phone;
    const email = marker.storeData.email;
    const address = marker.storeData.address;
    const zipCode = marker.storeData.zipcode;
    const city = marker.storeData.city;
    const is_not_able_to_select = marker.storeData.closed_days.length == 7 || !DJANGO.is_season_rental_enabled;

    const content = `
        <div class="store-info-box">

            <div class="name">
                ${store_name}
            </div>

            <div class="address">
                <div class="street">${address}</div>
                <div class="zipcode">${zipCode} ${city}</div>
                <div class="tel">${phone}</div>
                <div class="email-website"><a href="mailto:${email}">${email}</a></div>
            </div>

            <form action="." method="post" class="js-pickup-points-form">
                <input type="hidden" name="csrfmiddlewaretoken" value="${DJANGO.CSRF_TOKEN}">
                <input type="hidden" name="store_id" value="${id}">
                <button type="submit" class="c-button c-button--full-width-xs" style="${is_not_able_to_select ? 'display: none;' : ''}">${DJANGO.i18n['Select']}</button>
            </form>

            <div class="details">
                <a role="button" class="show-details" data-store-id="${id}">${DJANGO.i18n['Details & opening times']}</a>
            </div>

        </div>
    `;

    markerInfoWindow.setContent(content);
    markerInfoWindow.setPosition(marker.getPosition());
    markerInfoWindow.open(map);
}


function scaleMapToFitMakers(map, markerArr) {
    const mapBounds = new google.maps.LatLngBounds();

    for (const marker of markerArr) {
        mapBounds.extend(marker.getPosition());
    }

    map.fitBounds(mapBounds);
}


$(document).ready(() => {
    const isStoreLocatorPage = Boolean(document.querySelector(`#find-closest-store-btn`));
    if (isStoreLocatorPage) {
        document.querySelector(`#find-closest-store-btn`).addEventListener('click', () => {
            findNearbyStoresByGeolocatoin();
        });

        const searchBtn = document.getElementById(`store-locator-search-btn`);
        searchBtn.addEventListener('click', () => {
            const isFormValid = document.querySelector(`.c-search__form`).checkValidity();
            const searchInput = document.querySelector(`.c-search__form input[type=search]`);
            if (isFormValid) {
                findNearbyStores({address: searchInput.value});
            } else {
                findNearbyStoresByGeolocatoin();
            }
        });

        document.querySelector(`.c-search__form`).addEventListener('submit', (event) => {
            event.preventDefault();
            const isFormValid = event.target.checkValidity();
            const searchInput = document.querySelector(`.c-search__form input[type=search]`);
            if (isFormValid) {
                findNearbyStores({address: searchInput.value});
            } else {
                findNearbyStoresByGeolocatoin();
            }
        });

        document.querySelector(`#find-pick-up-point-header-btn`).addEventListener('click', () => {
            document.querySelector(`#store-locator-search-box`).scrollIntoView({behavior: `smooth`});
            findNearbyStoresByGeolocatoin();
        });
    }
    initStoreSelector();
});


function findNearbyStoresByGeolocatoin() {
    const searchErrorInfo = document.querySelector(`#store-locator-search-error`);
    searchErrorInfo.dataset.isVisible = false;

    activateStoreLoader();
    navigator.geolocation.getCurrentPosition(
        position => {
            const geocoderRequest = {
                location: {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                },
            };
            findNearbyStores(geocoderRequest);
        },
        positionError => {
            searchErrorInfo.isVisible = true;
        }
    );
}


function findNearbyStores(geocoderRequest) {
    const searchErrorInfo = document.querySelector(`#store-locator-search-error`);
    searchErrorInfo.dataset.isVisible = false;

    activateStoreLoader();
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode(
        geocoderRequest,
        (results, status) => {
            if (status === google.maps.GeocoderStatus.OK) {
                const result = results[0];
                const userPosition = result.geometry.location;
                map.setCenter(userPosition);

                const input = document.querySelector(`.js-c-search input[type='search']`);
                input.value = result.formatted_address;

                if (userMarker) {
                    userMarker.setMap(null);
                }
                userMarker = new google.maps.Marker({map: map, position: userPosition});
                scaleMapToFitMakers(map, markerArr.concat(userMarker));

                const markersByDistance = sortMakersByDistance(userPosition);

                let storesData = markersByDistance
                    .filter(markerObj => markerObj.distanceToUser <= 40000)  // 40km
                    .map(markerObj => markerObj.marker.storeData);

                const isTooLittleStores = storesData.length < 3;
                if (isTooLittleStores) {
                    storesData = markersByDistance.map(
                        markerObj => markerObj.marker.storeData
                    );
                    storesData = storesData.slice(0, 3);
                }

                $.ajax({
                    url: DJANGO.urls.storesSorting,
                    type: 'POST',
                    contentType: 'application/json; charset=utf-8',
                    data: JSON.stringify(storesData),
                    success: function (response) {
                        $(`#pickup-points`).html(response);
                        initStoreSelector();
                        deactivateStoreLoader();
                        $([document.documentElement, document.body]).animate({
                            scrollTop: $('#pickup-points').offset().top
                        }, 700);
                    }
                });
            } else {
                searchErrorInfo.dataset.isVisible = true;
                deactivateStoreLoader();
            }
        },
    );
}


function sortMakersByDistance(userPosition) {
    let markersWithDistance = [];

    for (let marker of markerArr) {
        const distanceToUser = google.maps.geometry.spherical.computeDistanceBetween(
            userPosition,
            marker.getPosition(),
        );

        markersWithDistance.push({marker: marker, distanceToUser: distanceToUser});
    }
    const markersSortedByUserDistance = markersWithDistance.sort(sortByDistance);
    return markersSortedByUserDistance;
}


function sortByDistance(a, b) {
    return (a.distanceToUser - b.distanceToUser)
}


function initStoreSelector() {
    $(document).on('click', '.store-info-box .show-details', function (ev) {
        let storeId = $(ev.target).data('store-id');
        $(`#store-id-${storeId}`).collapse('show');
        let elementToScroll = $(`#store-id-${storeId}`).closest('.js-c-card-place__col');
        $([document.documentElement, document.body]).animate({
            scrollTop: $(elementToScroll).offset().top
        }, 700);
    });

    $('.c-card-place__content-top').matchHeight();

    $('.js-pickup-points-form input').on('change', function () {
        $('.js-pickup-points-form').submit();
        $('.js-pickup-points-form input').prop('disabled', true);
    });

    // Select location from box
    $('.js-pickup-points-form .js-place-chooser').on('click', function (event) {
        if ($(event.target).hasClass('js-c-card-place__btn')) {
            return;
        }

        if (!DJANGO.is_season_rental_enabled) {
            return;
        }

        event.currentTarget.querySelector('[name=store_id]').checked = true;
        $('.js-pickup-points-form').submit();
        $('.js-pickup-points-form input').prop('disabled', true);
    });
}


function activateStoreLoader() {
    const loadingIndicator = document.querySelector(`.loading-indicator`);
    loadingIndicator.dataset.isVisible = String(true);
}

function deactivateStoreLoader() {
    const loadingIndicator = document.querySelector(`.loading-indicator`);
    loadingIndicator.dataset.isVisible = String(false);

}

module.exports = {initMapNew};



// WEBPACK FOOTER //
// ./private/js/season_rental/homepage/google_map.js